import moment from "moment";

import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { Guid } from "@/Common/Models/Guid";

window.IsNullOrUndefined = function(value: boolean | number | string): boolean {
    return value === null || value === undefined;
};

window.isGuidNullOrUndefinedOrEmpty = function(value: Guid | string): boolean {
    return !value || value == GuidHelper.Empty();
};

window.isArrayNullOrUndefinedOrEmpty = function<T>(arr: T[]): boolean {
    return !arr || arr.length === 0;
};

window.isImmutableListNullOrUndefinedOrEmpty = function<T>(arr: Immutable.List<T>): boolean {
    return !arr || arr.isEmpty();
};

window.areAllNullOrWhiteSpace = function(values: string[]): boolean {
    for (const val of values)
        if (!IsNullOrWhiteSpace(val))
            return false;

    return true;
};

window.IsNullOrWhiteSpace = function(value: string): boolean {
    return String.prototype.isNullOrWhiteSpace(value);
};

window.limitTextLength = function(value: string, length: number = 120): string {
    if (value == null) return "";
    if (value.length > length) {
        return value.slice(0, length) + "...";
    }
    else return value;
};

type Comparer<T> = (a: T, b: T) => number;

window.propertyComparer = function<T>(getProperty: (value: T) => any, reversed: boolean = false): Comparer<T> {
    return (cur: T, next: T) => {
        const curVal = getProperty(cur);
        const nextval = getProperty(next);

        let order = 0;

        if (curVal < nextval) {
            order = -1;
        }
        else if (curVal > nextval) {
            order = 1;
        }
        return reversed ? -order : order;
    };
};

window.propertyComparerDesc = function<T>(getProperty: (value: T) => any): Comparer<T> {
    return propertyComparer<T>(getProperty, true);
};

window.formatDate = function(date: moment.MomentInput, format: string = "YYYY-MM-DD @ HH:mm:ss"): string {
    return date
        ? moment(date).format(format)
        : "";
};

window.convertLocalDateOffsetToUtc = function(date: Date): Date {
    return moment.utc(date.format("YYYY-MM-DDTHH:mm:ss")).toDate();
};

window.toDateRange = function(dateFrom: string, dateTo: string): string {
    let dateRange = dateFrom ? moment(dateFrom).format("YYYY/MM/DD HH:mm:ss") : "--";
    if (dateTo && moment(dateFrom).format("YYYY/MM/DD HH:mm:ss") != moment(dateTo).format("YYYY/MM/DD HH:mm:ss")) {
        dateRange +=
            " "
            + cacheStore.GetString("ToDLabel")
            + " "
            + (moment(dateFrom).format("YYYY/MM/DD") == moment(dateTo).format("YYYY/MM/DD")
                ? moment(dateTo).format("HH:mm:ss")
                : moment(dateTo).format("YYYY/MM/DD HH:mm:ss")
            );
    }
    return dateRange;
};

window.compareNumbers = (num1: string | number | null | undefined, num2: string | number | null | undefined): boolean => {
    const parsedNum1 = num1 ? Number(num1) : null;
    const parsedNum2 = num2 ? Number(num2) : null;

    // Check if either value is NaN, and return false if so
    if (isNaN(parsedNum1) || isNaN(parsedNum2)) {
        return false;
    }

    return parsedNum1 === parsedNum2;
};
